/**
 * `@font-face` declarations for the bundled Taste fonts (ABC Dinamo trials
 * plus a few non-ABC display faces).
 *
 * These are emitted into the document only on flow pages whose flow was
 * created by an admin Taste swarm — see `<DinamoFontFaces />`. Keeping them
 * out of `app/globals.css` ensures user-created flows can't accidentally
 * (or deliberately) render with these fonts.
 *
 * Document-scoped (light DOM) so the screen frames' Shadow DOM can resolve
 * them too. Exported standalone HTML (`getScreenExportCode.ts`) inlines its
 * own copy, since that runs outside the app.
 */
export const DINAMO_FONT_FACE_CSS = `
@font-face {
  font-family: 'ABC Whyte Mono Variable';
  src: url('/fonts/dinamo/ABCWhyteMonoVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Marfa Mono Variable';
  src: url('/fonts/dinamo/ABCMarfaMonoVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Social Plus Variable';
  src: url('/fonts/dinamo/ABCSocialPlusVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Diatype Rounded Plus Variable';
  src: url('/fonts/dinamo/ABCDiatypeRoundedPlusVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Diatype Plus Variable';
  src: url('/fonts/dinamo/ABCDiatypePlusVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Gravity Variable';
  src: url('/fonts/dinamo/ABCGravityVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Otto Variable';
  src: url('/fonts/dinamo/ABCOttoVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Gramercy Standard Variable';
  src: url('/fonts/dinamo/ABCGramercyStandardVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Diatype Variable';
  src: url('/fonts/dinamo/ABCDiatypeVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Favorit Variable';
  src: url('/fonts/dinamo/ABCFavoritVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Favorit Mono Variable';
  src: url('/fonts/dinamo/ABCFavoritMonoVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Diatype Mono Variable';
  src: url('/fonts/dinamo/ABCDiatypeMonoVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Marist Variable';
  src: url('/fonts/dinamo/ABCMaristVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'ABC Solar Variable';
  src: url('/fonts/dinamo/ABCSolarVariable-Trial.woff2') format('woff2');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}

/* Non-ABC taste fonts. Single-weight files declared across the full 100 900
   range so any CSS font-weight resolves to the one file (same trick as the
   variable fonts above). Taste-scoped via <DinamoFontFaces> like the rest. */
@font-face {
  font-family: 'Futura PT Medium';
  src: url('/fonts/taste/futura-pt-medium.ttf') format('truetype');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'Fonseca Bold';
  src: url('/fonts/taste/fonseca-bold.otf') format('opentype');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
@font-face {
  font-family: 'NovaDeco Bold';
  src: url('/fonts/taste/novadeco-bold.ttf') format('truetype');
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}
`;
